import Container from "@client/content/Containers/container";
import { getContainerProps, getEntityRef } from "@client/content/lib/helper";
import ContentTextStyle from "@client/content/Style/Text";
import { type RootContainerProps } from "@client/content/types";
import HTML from "@client/controls/HTML/component";
import * as React from "react";

export type TwitterComponentProps = RootContainerProps & {
  baseUrl: string;
  numberOfTweets: string;
  twitterId: string;
};

interface Tweet {
  id: string;
  date: string;
  replyUrl: string;
  text: string;
}

interface State {
  isLoading: boolean;
  tweets: Tweet[];
}

export default class Component extends React.Component<TwitterComponentProps, State> {
  public state: State = {
    isLoading: false,
    tweets: []
  };

  public componentDidMount() {
    this._init(this.props);
  }

  public componentDidUpdate(
    prevProps: Readonly<TwitterComponentProps>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    if (prevProps.numberOfTweets !== this.props.numberOfTweets || prevProps.twitterId !== this.props.twitterId) {
      this._init(this.props);
    }
  }

  public render() {
    return (
      <Container {...getContainerProps(this.props)}>
        <ContentTextStyle {...getEntityRef(this.props)} />

        <div className="widget widget-twitter">
          {this.state.tweets.map((tweet) => (
            <div key={tweet.id} className="twitter-cnt">
              <ul>
                <li>
                  <HTML tag="span" html={tweet.text} />
                  <small>
                    <span className="tweet_time">{tweet.date}</span> -{" "}
                    <a target="_blank" href={tweet.replyUrl} className="feedItem">
                      reply
                    </a>
                  </small>
                </li>
              </ul>
            </div>
          ))}
        </div>
      </Container>
    );
  }

  private _init = (props: TwitterComponentProps) => {
    if (this.state.isLoading) return;

    this.setState({ isLoading: true });
    // TODO
    // request<ApiResponse<Twitter.Api.InitResponse>>({method: "GET", url: `${props.baseUrl}/Modules/Twitter/Init?${props.twitterId}`})
    //   .then(
    //     (resp) => {
    //       if (!this._isMounted) return;

    //       const data = resp.slice(0, +props.numberOfTweets);

    //       this.setState({
    //         isLoading: false,
    //         tweets: data.map(item => ({
    //           id: item.id_str,
    //           date: formatDate(item.created_at),
    //           replyUrl: `https://twitter.com/intent/tweet?in_reply_to=${item.id_str}`,
    //           text: expandUrls(item.text, item.entities.urls.map((u: any) => ({expandedUrl: u.expanded_url, url: u.url})))
    //         }) as Tweet)
    //       });
    //     }
    //   );
  };
}
